import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element";
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// import '@/styles/index.css';
import i18n from "./assets/i18n/i18n";
// import Echart from 'echarts';
import VueClipboard from "vue-clipboard2";
import '@/styles/table.css';
// Vue.prototype.$echarts = Echart;
// import '@/permission'; // permission control
// Vue.use(ElementUI);
import { Loading } from 'element-ui';
Vue.use(Loading.directive);
Vue.use(VueClipboard);
Vue.config.productionTip = false;
Vue.prototype.$selfRouter = router;
Vue.filter("formatTime", function(time: number) {
  if (!time) return "---";
  function addZero(val: any) {
    if (val < 10) {
      val = "0" + val;
    }
    return val;
  }
  let date: any = new Date(time);
  let month: any = addZero(date.getMonth() + 1);
  let day: any = addZero(date.getDate());
  var yearMonthDay = date.getFullYear() + "-" + month + "-" + day;
  var hoursMS =
    addZero(date.getHours()) +
    ":" +
    addZero(date.getMinutes()) +
    ":" +
    addZero(date.getSeconds());
  return yearMonthDay + " " + hoursMS;
});
Vue.filter("formatNull", function(val: any) {
  if (!val && val != 0) {
    return "---";
  }
  return val;
});
Vue.filter("formatZeroNull", function(val: any) {
  if (!val) {
    return "---";
  }
  return val;
});
Vue.filter("formatStringZeroNull", function(val: any) {
  if (!val || val === "0") {
    return "---";
  }
  return val;
});
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
